import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[roblexCollapsedSidepanelInsertion]'
})
export class CollapsedSidepanelInsertionDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
